import React from "react";
import PropTypes from "prop-types";
//
import parse from "html-react-parser";
import Link from "@mui/material/Link";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import { makeStyles } from "@material-ui/styles";
import { MARK_STYLE, FONT_SIZE } from "../option";
import { markKeyword, markKeywords } from "../dataHelper";

//
const useStyles = makeStyles((theme) => ({
  button: {
    // margin: theme.spacing(1),
  },
  customWidth: {
    maxWidth: 500,
    maxHeight: "400px",
    overflow: "auto",
    fontSize: "1.2rem",
  },
  noMaxWidth: {
    maxWidth: "none",
  },
}));

const defaultFontSize = {
  tableCell: "0.875rem",
  tableHead: "1rem",
};

const MarkOrNot = ({ text, keyword, useMark, markStyle }) => {
  if (useMark) {
    const defaultStyle =
      markStyle in MARK_STYLE ? MARK_STYLE[markStyle] : MARK_STYLE.primary;
    return parse(markKeywords(text, keyword, defaultStyle.css));
  }
  return text || "";
};

const CustomTableCell = ({
  header,
  rowData,
  handleClickLink,
  fontSize,
  keyword,
  markStyle = MARK_STYLE.primary.name,
}) => {
  const classes = useStyles();

  const getLinkText = () => (
    <Link
      href={rowData.url}
      onClick={handleClickLink}
      target="_blank"
      rel="noreferrer noopener"
    >
      <Box fontSize={fontSize}>
        <MarkOrNot
          text={rowData[header.id]}
          keyword={keyword}
          useMark={header.useMark}
          markStyle={markStyle}
        />
      </Box>
    </Link>
  );

  const getButton = () => (
    <Button className={classes.button}>
      <Box fontSize={fontSize || defaultFontSize.tableCell} textAlign="left">
        <MarkOrNot
          text={rowData[header.id]}
          keyword={keyword}
          useMark={header.useMark}
          markStyle={markStyle}
        />
      </Box>
    </Button>
  );

  const getTooltipText = () =>
    (rowData[header.id] && (
      <Tooltip
        interactive
        title={rowData[header.id] || ""}
        classes={{ tooltip: classes.customWidth }}
      >
        {getButton()}
      </Tooltip>
    )) ||
    getButton();

  const getSimpleText = () => (
    <Box fontSize={fontSize || defaultFontSize.tableCell} textAlign="left">
      <MarkOrNot
        text={rowData[header.id]}
        keyword={keyword}
        useMark={header.useMark}
        markStyle={markStyle}
      />
    </Box>
  );

  const getTableCellInner = () => {
    const { useLink, useTooltip } = header;
    if (useLink) {
      return getLinkText();
    }
    if (useTooltip) {
      return getTooltipText();
    }
    return getSimpleText();
  };

  const getStyle = () => {
    if (header.style) return header.style;
    return {};
  };

  return (
    header?.id &&
    rowData && (
      <TableCell component="th" scope="row" align="center" sx={getStyle()}>
        {getTableCellInner()}
      </TableCell>
    )
  );
};

CustomTableCell.defaultProps = {
  header: undefined,
  rowData: undefined,
  handleClickLink: () => null,
  fontSize: undefined,
  keyword: undefined,
  markStyle: undefined,
};

CustomTableCell.propTypes = {
  header: PropTypes.objectOf(PropTypes.any),
  rowData: PropTypes.objectOf(PropTypes.any),
  handleClickLink: PropTypes.func,
  fontSize: PropTypes.string,
  keyword: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  markStyle: PropTypes.string,
};

export default CustomTableCell;
